import { useMemo, useState } from "react";
import usePersistStickyFilters from "./usePersistStickyFilters";
import {
  VENDOR_STICKY_SCREEN_KEYS,
  loadDiscoveryStickyFilterState,
  persistVendorStickyFilterState,
} from "../utils/vendorStickyFilterPersistence";

/**
 * Sticky Vendor Discovery filter UI state (sessionStorage hydrate + persist).
 */
export default function useDiscoveryVendorFiltersSticky(
  screenKey = VENDOR_STICKY_SCREEN_KEYS.DISCOVERY
) {
  const initialVendorFilters = useMemo(
    () => loadDiscoveryStickyFilterState(screenKey).vendorFilters,
    [screenKey]
  );

  const [selectedVendors, setSelectedVendors] = useState(
    initialVendorFilters.selectedVendors
  );
  const [selectedTAIndications, setSelectedTAIndications] = useState(
    initialVendorFilters.selectedTAIndications
  );
  const [selectedCategories, setSelectedCategories] = useState(
    initialVendorFilters.selectedCategories
  );
  const [selectedVendorType, setSelectedVendorType] = useState(
    initialVendorFilters.selectedVendorType
  );
  const [selectedDataAvailability, setSelectedDataAvailability] = useState(
    initialVendorFilters.selectedDataAvailability
  );
  const [selectedEmployeeSizes, setSelectedEmployeeSizes] = useState(
    initialVendorFilters.selectedEmployeeSizes
  );
  const [selectedDocAvail, setSelectedDocAvail] = useState(
    initialVendorFilters.selectedDocAvail
  );
  const [selectedRevenueRanges, setSelectedRevenueRanges] = useState(
    initialVendorFilters.selectedRevenueRanges
  );
  const [locationFilters, setLocationFilters] = useState(
    initialVendorFilters.locationFilters
  );

  const stickyVendorFilters = useMemo(
    () => ({
      vendorFilters: {
        selectedVendors,
        selectedCategories,
        selectedVendorType,
        selectedTAIndications,
        selectedDocAvail,
        selectedDataAvailability,
        selectedEmployeeSizes,
        selectedRevenueRanges,
        locationFilters,
      },
    }),
    [
      selectedVendors,
      selectedCategories,
      selectedVendorType,
      selectedTAIndications,
      selectedDocAvail,
      selectedDataAvailability,
      selectedEmployeeSizes,
      selectedRevenueRanges,
      locationFilters,
    ]
  );

  usePersistStickyFilters(
    screenKey,
    stickyVendorFilters,
    persistVendorStickyFilterState
  );

  return {
    selectedVendors,
    setSelectedVendors,
    selectedTAIndications,
    setSelectedTAIndications,
    selectedCategories,
    setSelectedCategories,
    selectedVendorType,
    setSelectedVendorType,
    selectedDataAvailability,
    setSelectedDataAvailability,
    selectedEmployeeSizes,
    setSelectedEmployeeSizes,
    selectedDocAvail,
    setSelectedDocAvail,
    selectedRevenueRanges,
    setSelectedRevenueRanges,
    locationFilters,
    setLocationFilters,
  };
}
